import {ICatalogo} from "../../entities/catalogos/ICatalogo";

export const LOAD_TIPOS_SEGURO_OBSERVACION_SUCCESS = 'LOAD_TIPOS_SEGURO_OBSERVACION_SUCCESS';


interface ILoadTipoSeguroObservacion {
    type: typeof LOAD_TIPOS_SEGURO_OBSERVACION_SUCCESS
    tiposSeguroObservacion: ICatalogo[]
}

export type TipoSeguroObservacionActionTypes = ILoadTipoSeguroObservacion
